//import { JsonForms } from '@jsonforms/react';
//import { materialRenderers, materialCells } from '@jsonforms/material-renderers';
import { withJsonFormsControlProps } from '@jsonforms/react';
import { Box } from '@mui/material';

// Кастомный рендерер для Table head
const CustomTableLabelRenderer = (props) => {
  const { data, handleChange, path, schema, uischema, errors, visible } = props;

  // Обработчик изменения значения
  //const handleInputChange = (event) => {
    //const newValue = event.target.value;
    //Добавляем префикс "Hello, " к значению
    //handleChange(path, newValue ? `Hello, ${newValue}` : '');
  //};

  // Если элемент невидим, не рендерим ничего
  if (!visible) {
    return null;
  }

  const width = uischema.options.width ? uischema.options.width : undefined

  const sx = {color: 'rgb(0,83,146)', 
        marginTop: 2, 
        marginBottom: 10, 
        border: 1, 
        borderRadius: 1, 
        height: "85%", 
        padding: "12px", 
        display: "flex", 
        alignItems: "center",
        justifyContent: "center",
        fontWeight: 600,
        width: width
  }

  return (
    <Box sx={sx}>
        {/*<InputLabel>{uischema.label || schema.title || 'Custom Input'}</InputLabel>*/}
        <p>{uischema.text}</p>
    </Box>
  );
};

// Оборачиваем рендерер с помощью withJsonFormsControlProps
export const CustomTableLabelControl = withJsonFormsControlProps(CustomTableLabelRenderer);


// Кастомный рендерер для Fixedcell
const CustomFixedcellLabelRenderer = (props) => {
  const { data, handleChange, path, schema, uischema, errors, visible } = props;

  // Если элемент невидим, не рендерим ничего
  if (!visible) {
    return null;
  }

  const width = uischema.options.width ? uischema.options.width : undefined

  let sx={ 
        color: 'rgb(0,83,146)', 
        marginTop: 0, 
        marginBottom: 1, 
        border: 1, 
        borderRadius: 1, 
        //height: "85%", 
        paddingTop: "14px", 
        paddingBottom: "14px", 
        display: "flex", 
        alignItems: "center",
        justifyContent: "center",
        fontSize: 14, 
        fontWeight: 600,
        //minWidth: 160,
        width: width
      }

  return (
    <Box sx={sx}>
      <p style={{margin: "2px"}}>{uischema.text}</p>
    </Box>
  );
};

// Оборачиваем рендерер с помощью withJsonFormsControlProps
export const CustomFixedcellLabelControl = withJsonFormsControlProps(CustomFixedcellLabelRenderer);



// Renderer for Labels that are Group elements //
////////////////////////////////////////////////


const ExternalLabelRenderer = (props) => {
  const { data, handleChange, path, schema, uischema, errors, visible } = props;

  if (!visible) {
    return null;
  }

  const width = uischema.options.width ? uischema.options.width : undefined
  const fontSize = uischema.options.labelSize === 'small' ? '1rem' : '1.25rem'
  const color = uischema.options.labelColor ? uischema.options.labelColor : undefined

  return (
    <Box sx={{ 
        //color: 'rgb(0,83,146) !important' 
        marginTop: 1, 
        marginBottom: 0, 
        width: width,
        //fontSize: '2rem !important'
      }}>
      {/*<InputLabel>{uischema.label || schema.title || 'Custom Input'}</InputLabel>*/}
      <h6 style={{ 
        fontSize: fontSize, 
        color: color 
      }}>
        {uischema.text}
      </h6>
    </Box>
  );
};

export const ExternalLabelControl = withJsonFormsControlProps(ExternalLabelRenderer);
